import {Table} from '@/web-components';
import React from 'react';
import {Tooltip} from '@forecast-it/design-system';
import {TooltipFormulaRenderer} from '../../TooltipFormulaRenderer';
import {useIntl} from 'react-intl';
import Util from '../../../forecast-app/shared/util/util';
import {ProjectPortfolioReportTooltips} from './ProjectPortfolioReportTooltips';

type HoursColumnProps = {
	value: number;
	showWinProbabilityTooltip: boolean;
};

export const HoursColumn = ({value, showWinProbabilityTooltip = false}: HoursColumnProps): JSX.Element => {
	const intl = useIntl();
	const {formatMessage} = intl;

	const winProbabilityTooltip = ProjectPortfolioReportTooltips.GenericWinChanceTooltip(formatMessage);

	const content = value ? Util.convertMinutesToFullHour(value, intl) : '-';

	return (
		<Table.Column align={'right'} usePadding negative={value < 0}>
			{showWinProbabilityTooltip ? (
				<Tooltip content={<TooltipFormulaRenderer items={winProbabilityTooltip} />} interactable={false}>
					{content + '*'}
				</Tooltip>
			) : (
				content
			)}
		</Table.Column>
	);
};
